import { useState } from 'react';
import { Link } from 'react-router-dom';
import { hotRecommends } from '@/mocks/comics';

export default function HotRecommendSection() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 font-bold">
            热门推荐 <span className="text-primary-500">🔥</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-500">精选最受欢迎的蜜桃少年漫画系列</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {hotRecommends.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className={`group relative rounded-2xl overflow-hidden transition-all duration-500 cursor-pointer ${
                hoveredIndex === index
                  ? 'md:col-span-1 md:scale-[1.02]'
                  : hoveredIndex !== null
                  ? 'md:opacity-60 md:scale-[0.98]'
                  : ''
              }`}
              style={{ aspectRatio: '3/4' }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              data-product-shop=""
            >
              <img
                src={comic.coverImage}
                alt={`${comic.title} - 89890漫画网热门推荐`}
                title={`${comic.title} - 免费在线阅读`}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent"></div>

              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500/90 text-background-50 rounded-full whitespace-nowrap">
                    {comic.category}
                  </span>
                  <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded-full whitespace-nowrap">
                    {comic.status}
                  </span>
                </div>
                <h3 className="text-lg md:text-xl font-heading text-background-50 font-bold">
                  {comic.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-background-200/80 line-clamp-2 leading-relaxed">
                  {comic.description}
                </p>
                <div className="mt-3 flex items-center gap-3 text-xs text-background-300/70">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-400 text-xs"></i>
                    {comic.rating}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(comic.views / 10000).toFixed(0)}万
                  </span>
                  <span>{comic.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}